<script lang="ts">
    import MainLayout from '../#common/layout/Layout.svelte'
    import { Table } from 'sveltestrap'
    import {Link} from 'svelte-routing'
    import {
        addRoleToUser,
        getAllRoles,
        deleteUserRole,
        updateUserRole,
        deleteRole
    } from 'src/components/cabinet/#services/adminRoles'
    import Modal from 'src/components/cabinet/#common/modal/Modal.svelte.ts'
    import {getAdminsList} from 'src/components/cabinet/#services/getAdminsList'
    import IconifyIcon from '@iconify/svelte'
    import editIcon from '@iconify/icons-fa-solid/pencil-alt'
    import deleteIcon from '@iconify/icons-fa-solid/times'
    import {doShow as showAlert} from 'src/components/#common/alert/store'

    let userId = ''
    let field
    let selected;
    let selectedNickname = ''
    let selectedUserId
    let selectedRole = ''
    let addUserRoleModal = false
    let deleteUserRoleModal = false
    let deleteRoleModal = false

    function getAdminsListFunc() {
        getAdminsList.reset()
        getAdminsList.send({ data: { isActive: true } })
    }

    getAllRoles.send()
    getAdminsListFunc()

    async function updateUserRoleFunc(userId,role) {
         try {
             await updateUserRole.request({
                 data: {
                     userId: userId,
                     roleName: role
                 }
             })

             showAlert.set({
                 status: 'success',
                 text: 'Role successfully updated'
             })
         } catch (err) {
             if (err.message) {
                 showAlert.set({
                     status: 'error',
                     text: err.message
                 })
             } else {
                 showAlert.set({
                     status: 'error',
                     text: 'An Error Occurred, Please Try Again Later'
                 })
             }
         } finally {
             getAdminsListFunc()
         }
    }

    async function addUserRole() {
        try {
            await addRoleToUser.request({ data: { internalUserId: userId, roleName: selected } })

            showAlert.set({
                status: 'success',
                text: 'Administrator successfully added'
            })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            addUserRoleModal = false
            getAdminsListFunc()
        }
    }

    async function deleteRoleFunc(roleName) {
        try {
            await deleteRole.request({ data: { roleName } })

            showAlert.set({
                status: 'success',
                text: 'Role successfully deleted'
            })
            window.scrollTo(0, 0)
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            deleteRoleModal = false
            getAllRoles.reset()
            getAllRoles.send()
            getAdminsListFunc()
        }
    }

    async function deleteUserRoleFunc() {
        try {
            await deleteUserRole.request({ data: { internalUserId: selectedUserId } })

            showAlert.set({
                status: 'success',
                text: 'Administrator successfully removed'
            })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            deleteUserRoleModal = false
            getAdminsListFunc()
        }
    }

    async function changeRole(event, userId) {
        try {
            await updateUserRole.request({ data: { internalUserId: userId, roleName: event.target.value } })

            showAlert.set({
                status: 'success',
                text: 'Administrator role successfully changed'
            })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            getAdminsListFunc()
        }
    }
</script>

<svelte:head>
    <title>Administrators</title>
</svelte:head>

<MainLayout title="Administrators">
    <svelte:fragment slot="content">
        <div class="card">
            <div class="card-body">
                <div class="administrators-buttons">
                    <Link to="administrators/role/add" class="btn btn-success mb-3">Create role</Link>
                    <button class="btn btn-primary mb-3" on:click={() => { addUserRoleModal = true }}>Add admin</button>
                </div>
                <div class="administrators-list">
                    <Table bordered striped hover responsive>
                        <thead>
                            <tr>
                                <td>Nickname</td>
                                <td>Role</td>
                                <td>Remove</td>
                            </tr>
                        </thead>
                        <tbody>
                            {#if $getAdminsList.loading}
                                <tr>
                                    <td class="text-center" colSpan="3">Loading...</td>
                                </tr>
                            {:else if $getAdminsList.error || !$getAdminsList.hasValue }
                                <tr>
                                    <td class="text-center" colspan="3">Something went wrong. Try refreshing the page.</td>
                                </tr>
                            {:else if $getAdminsList.hasValue}
                                {#each $getAdminsList.value as {nickname, role, userId, email}}
                                    <tr>
                                        <td><a href="/profile/{userId}" target="_blank" rel="noreferrer">{email}</a></td>
                                        <td>
                                            {#if role === "SuperAdmin"}
                                                <select class="form-select" disabled>
                                                    <option selected>Super administrator</option>
                                                </select>
                                            {:else}
                                                {#if $getAllRoles.loading}
                                                    <tr>
                                                        <td><span class="loading transaction-loading"></span></td>
                                                    </tr>
                                                {:else if $getAllRoles.error || !$getAllRoles.hasValue }
                                                    <tr>
                                                        <td class="text-center" colspan="3">Something went wrong. Try refreshing the page.</td>
                                                    </tr>
                                                {:else}
                                                    <select class="form-select" on:change={(e) => changeRole(e, userId)} value={role}>
                                                        {#each $getAllRoles.value as role}
                                                            {#if role.name != 'SuperAdmin'}
                                                                <option value={role.name}>{role.name}</option>
                                                            {/if}
                                                        {:else}
                                                            <option disabled>No roles</option>
                                                        {/each}
                                                    </select>
                                                {/if}
                                            {/if}
                                        </td>
                                        <td>
                                            <button class="btn btn-danger" on:click={() => {deleteUserRoleModal = true; selectedNickname = nickname; selectedRole = role; selectedUserId = userId }} disabled={role == 'SuperAdmin'}>
                                                <IconifyIcon icon={deleteIcon}/>
                                            </button>
                                        </td>
                                    </tr>
                                {/each}
                            {/if}
                        </tbody>
                    </Table>
                    <Modal bind:visible={deleteUserRoleModal}>
                        <svelte:fragment slot="content">
                            <div class="modal-custom__title">Remove administrator</div>
                            <div>Are you sure you want to remove the user {selectedNickname} from administrators?</div>
                            <div class="modal-custom__footer">
                                <button class="btn btn-cancel" on:click={() => { deleteUserRoleModal = false }}>Cancel</button>
                                <button class="btn btn-primary" on:click={deleteUserRoleFunc}>Yes</button>
                            </div>
                        </svelte:fragment>
                    </Modal>
                </div>
            </div>
        </div>

        <div class="card">
            <div class="card-body roles-list">
                <h5><strong>Roles</strong></h5>
                <hr>
                <p><strong>Super Administrator</strong> - Has all rights. Founder only.</p>
                <hr>
                {#if $getAllRoles.loading}
                    <p>Loading...</p>
                {:else if $getAllRoles.error || !$getAllRoles.hasValue }
                    <p>Something went wrong. Try refreshing the page.</p>
                {:else if $getAllRoles.hasValue}
                    {#each $getAllRoles.value as role}
                        {#if role.name != "SuperAdmin"}
                            <p>
                                <strong>{role.name}
                                    <Link to="administrators/role/edit/{role.name}" class="edit-role-btn">
                                        <IconifyIcon icon={editIcon}></IconifyIcon>
                                    </Link>
                                    <button class="delete-role-btn" on:click={() => { deleteRoleModal = true; selectedRole = role.name }}>
                                        <IconifyIcon icon={deleteIcon}></IconifyIcon>
                                    </button>
                                </strong>
                            </p>
                            <hr>
                        {/if}
                    {/each}
                {/if}
                <Modal bind:visible={deleteRoleModal}>
                    <svelte:fragment slot="content">
                        <div class="modal-custom__title">Delete role</div>
                        <div class="modal-custom__text">Are you sure you want to remove the <strong>{selectedRole}</strong> role?</div>
                        <div class="modal-custom__footer">
                            <button class="btn btn-cancel" on:click={() => { deleteRoleModal = false }}>Cancel</button>
                            <button class="btn btn-primary" on:click={() => deleteRoleFunc(selectedRole)}>Confirm</button>
                        </div>
                    </svelte:fragment>
                </Modal>
            </div>
        </div>

        <Modal bind:visible={addUserRoleModal}>
            <svelte:fragment slot="content">
                <div class="modal-custom__title">Add new administrator</div>
                <label>User</label>
                <input type="text" class="form-control mb-3" bind:value={userId} {field} placeholder="Enter userId" autofocus>
                <label>Role</label>
                {#if $getAllRoles.loading}
                    <p>Loading...</p>
                {:else if $getAllRoles.error || !$getAllRoles.hasValue }
                    <p>Something went wrong. Try refreshing the page.</p>
                {:else}
                    <select class="form-select w-100" bind:value={selected}>
                        {#each $getAllRoles.value as role}
                            {#if role.name != 'SuperAdmin'}
                                <option value={role.name}>{role.name}</option>
                            {/if}
                        {/each}
                    </select>
                {/if}
                <div class="modal-custom__footer">
                    <button class="btn btn-cancel" on:click={() => {addUserRoleModal = false }}>Cancel</button>
                    <button class="btn btn-primary" on:click={addUserRole}>Add</button>
                </div>
            </svelte:fragment>
        </Modal>
    </svelte:fragment>
</MainLayout>

<style>
    select {
        width: auto;
        margin: 0 auto;
    }

    .administrators-list :global(td) {
        text-align: center;
        vertical-align: middle;
    }

    .administrators-buttons :global(*) {
        vertical-align: top;
        display: inline-block;
        margin-right: 5px;
    }

    .roles-list :global(.edit-role-btn) {
        color: #ff5d1c;
        margin: 0 3px;
        vertical-align: middle;
    }

    .roles-list .delete-role-btn {
        color: #f44336;
        padding: 0;
        border: 0;
        background: none;
        margin: 0 10px 0 3px;
        vertical-align: middle;
        float: right;
    }
</style>
